import { Box, Breadcrumbs, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// components
import ActionFooter from "../../components/ActionFooter";
import FullScreenLoading from "../../components/FullScreenLoading";
import Skeleton from "../../components/category/Skeleton";
import History from "../../components/inventory/History";
import BaseInfo from "../../components/inventory/BaseInfo";

// api
import { InventoryApi } from "../../api/InventoryApi";

export default function Edit() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState({
    id: null,
    name: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [fullScreenLoading, setFullScreenLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      navigate(-1);
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await InventoryApi.details(id);
      setData(response);

    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const update = async () => {
    try {
      if (!inventory.name) {
        toast.error(t("error.please_fill_in_this_field"));
        return;
      }

      setFullScreenLoading(true);

      const success = await InventoryApi.update(id, data);
      if (success) {
        toast.success(t("layout.updated_successfully"));
      }

    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const deleteData = async () => {
    try {
      setFullScreenLoading(true);
      const success = await InventoryApi.deleteData(id);
      if (success) {
        toast.success(t("layout.deleted_successfully"));
        navigate("/inventory");
      }

    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const onCancel = () => {
    navigate(-1);
  };

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Container maxWidth="false">
      <FullScreenLoading open={fullScreenLoading} />
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <Link to={"/inventory"}>{t("menu.inventory")}</Link>
        <Typography color="text.primary">{t("layout.edit")}</Typography>
      </Breadcrumbs>
      <Box component="form">
        <BaseInfo data={data} setData={setData} deleteData={deleteData} />
        <Box sx={{ my: 5 }} />
        <History InventoryId={id} />
        <Box sx={{ my: 8 }} />
        <ActionFooter onSubmit={update} onCancel={onCancel} />
      </Box>
    </Container>
  );
}
